module.exports = __webpack_public_path__ + "static/img/02009A_1_C_20210228_LC.4d4dae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02009A_1_C_20210228_LC.png
// module id = pGNA
// module chunks = 0